import * as t from 'io-ts';

import {makeSafeArrayType} from '../../types/arrayTypes';
import {LastWriterWinsValue, mergeLastWriterWinsValue} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RAskCopilotPromptTemplate = t.type({
  id: t.string,
  text: t.string,
});

export const RAskCopilotPromptTemplates = t.type({
  updatedAt: t.number,
  templates: makeSafeArrayType(RAskCopilotPromptTemplate),
});

/*
 * Types.
 */

export type AskCopilotPromptTemplate = t.TypeOf<typeof RAskCopilotPromptTemplate>;
export type AskCopilotPromptTemplates = t.TypeOf<typeof RAskCopilotPromptTemplates> & LastWriterWinsValue;

/*
 * Defaults.
 */

export const defaultAskCopilotPromptTemplates: AskCopilotPromptTemplates = {
  updatedAt: 0,
  templates: [],
};

/*
 * Merge strategy.
 */

export const mergeAskCopilotPromptTemplates = mergeLastWriterWinsValue<AskCopilotPromptTemplates>;
